// subscription/src/authHeaders.js
//
// 🔐 Shared auth helpers for authenticated portal API calls.
//
// The session token is NO LONGER stored in localStorage — it lives in a
// server-side HttpOnly cookie (`wurq_session`) set by the backend at OTP
// verification. Client-side JavaScript (including any 3rd-party scripts)
// can never read it. All we do here is make sure every axios request sends
// cookies (`withCredentials: true`) — the equivalent of
// `credentials: 'include'` for fetch().

import axios from "axios";

axios.defaults.withCredentials = true;

/**
 * True when an axios error represents an auth failure from the server:
 * 401 (Unauthorized — session expired/invalid) or 403 (Forbidden —
 * authenticated but not permitted). Use this instead of hardcoding
 * `err?.response?.status === 401` so both cases trigger the logout flow.
 */
export function isAuthError(err) {
  const status = err?.response?.status;
  return status === 401 || status === 403;
}

export function redirectToSafeLogin() {
  localStorage.removeItem("user_email");
  // Best-effort: ask the server to clear the session cookie too.
  axios.post(`${process.env.REACT_APP_API_URL || ""}/api/logout`).catch(() => {});
  const { origin, pathname } = window.location;
  window.location.assign(`${origin}${pathname}`);
}
